import imgCamisa03 from '../assets/img/img-camisa-03.jpeg';
import imgCamisa04 from '../assets/img/img-camisa-04.jpeg';
import imgCamisa05 from '../assets/img/img-camisa-05.jpeg';
import imgMoletom01 from '../assets/img/img-moletom-01.jpeg';
import imgMoletom02 from '../assets/img/img-moletom-02.jpeg';
import imgMoletom06 from '../assets/img/img-moletom-06.jpeg';

export const PRODUTOS = [
  {
    id: 1,
    nome: 'Camiseta Gatos — Amor Felino',
    desc: 'Feitas para acompanhar você em qualquer momento, sem deixar o conforto.',
    preco: 'R$ 79,90',
    badge: 'Essencial',
    imagens: [imgCamisa03, imgCamisa04],
  },
  {
    id: 2,
    nome: 'Camiseta Cãozinho Feliz',
    desc: 'Básicas, versáteis e sempre atuais. As queridinhas para quem ama os animais.',
    preco: 'R$ 79,90',
    badge: 'Mais vendidas',
    imagens: [imgCamisa05, imgMoletom06],
  },
  {
    id: 4,
    nome: 'Moletom Pata Amanimal',
    desc: 'Conforto no dia a dia com a marquinha que representa nosso amor pelos bichos.',
    preco: 'R$ 149,90',
    badge: 'Edição ilimitada',
    imagens: [imgMoletom01, imgMoletom02],
  },
];
